// a deep cloner that ensures getters/setter remain
// it works by passing the object thru a port to strip all refrences 
// then reconstructing objects to recreate getters/setters

//async or syncro clone available

/*
import { cloneAsync, deepClone } from "../../utils";

         const cloned = yield call(cloneAsync, item); //in saga
         const cloned = await cloneAsync(item); // in async func
         cloneAsync(item)
            .then(cloned => cloned) //in prom

*/


class DeepCloneImpl {
   constructor() {
      this.pendingClones_ = new Map();
      this.nextKey_ = 0;

      const channel = new MessageChannel();
      this.inPort_ = channel.port1;
      this.outPort_ = channel.port2;

      this.outPort_.onmessage = ({ data: { key, value } }) => {
         const item = this.pendingClones_.get(key);
         //ctor new object to create getters/setters
         const clone = this.remakeGettersSetters(value, item.original);
         item.resolve(clone);
         this.pendingClones_.delete(key);
      };
      this.outPort_.start();
   }

   remakeGettersSetters(obj, orig) {
      if(obj === null || obj === undefined){
         return null;
      }
      if (Array.isArray(obj)) {
         for (let i = 0; i < obj.length; i++) {
            const item = obj[i];
            if (typeof item === "object" && item !== null) {
               this.remakeGettersSetters(item, orig[i]);
            }
         }
         return obj;
      } else {
         let clone = Object.create(Object.getPrototypeOf(orig));
         for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
               if (typeof obj[prop] === "object" && obj[prop] !== null) {
                  clone[prop] = this.remakeGettersSetters(obj[prop], orig[prop]);
               } else {
                  clone[prop] = obj[prop];
               }
            }
         }
         return clone;
      }
   }

   cloneAsync(value) {
      return new Promise(resolve => {
         const key = this.nextKey_++;
         this.pendingClones_.set(key, { resolve, original: value });
         this.inPort_.postMessage({ key, value });
      });
   }
}
const inst = new DeepCloneImpl();

export const cloneAsync = DeepCloneImpl.prototype.cloneAsync.bind(inst);

// a deep cloner that ensures getters/setter/Types remain

function newOfType(obj) {
	if (obj === null || obj === undefined || typeof obj !== "object") {
		return obj;
	}
	return Object.create(Object.getPrototypeOf(obj));
}

function clone(obj, orig) {
	if (orig === null || orig === undefined) {
		return orig;
	}
	if (Array.isArray(orig)) {
		obj = new Array(orig.length);
		for (let i = 0; i < orig.length; i++) {
			const item = orig[i];
			obj[i] = clone(newOfType(item), item);
		}
	} else if (orig instanceof Date) {
		obj = new Date(orig);
	} else if (typeof orig === "object" && orig !== null) {
		for (var prop in orig) {
			if (orig.hasOwnProperty(prop)) {
				const item = orig[prop];
				if (item instanceof Date) {
					obj[prop] = new Date(item);
				} else if ((typeof item === "object" && item !== null) || Array.isArray(item)) {
					obj[prop] = clone(newOfType(item), item);
				} else {
					obj[prop] = item;
				}
			}
		}
	} else {
		obj = orig;
	}
	return obj;
}

export function deepClone(obj) {
	return clone(newOfType(obj), obj);
}





// WEBPACK FOOTER //
// ./src/utils/deepCloner.js